import { render, staticRenderFns } from "./bootstrap.vue?vue&type=template&id=868cdee8&"
import script from "./bootstrap.vue?vue&type=script&lang=ts&"
export * from "./bootstrap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports